"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactCircularProgressbar = _interopRequireDefault(require("react-circular-progressbar"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

require("react-circular-progressbar/dist/styles.css");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-family: ", ";\n  font-size: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: ", ";\n  height: ", ";\n  & > div {\n    position: absolute;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ProgressBar = _styledComponents.default.div(_templateObject(), function (props) {
  switch (props.size) {
    case 'xs':
      return '40px';

    case 'small':
      return '50px';

    case 'medium':
      return '60px';

    case 'large':
      return '70px';

    default:
      return '40px';
  }
}, function (props) {
  switch (props.size) {
    case 'xs':
      return '40px';

    case 'small':
      return '50px';

    case 'medium':
      return '60px';

    case 'large':
      return '70px';

    default:
      return '40px';
  }
});

var Text = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.theme.typography.fontFamily;
}, function (props) {
  return props.fontSize;
});

var CustomTextProgressbar = function CustomTextProgressbar(_ref) {
  var size = _ref.size,
      fontSize = _ref.fontSize,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["size", "fontSize", "children"]);

  return _react.default.createElement(ProgressBar, {
    size: size
  }, _react.default.createElement("div", null, _react.default.createElement(_reactCircularProgressbar.default, props)), _react.default.createElement(Text, {
    fontSize: fontSize
  }, children));
};

var Donut = function Donut(_ref2) {
  var value = _ref2.value,
      max = _ref2.max,
      color = _ref2.color,
      strokeWidth = _ref2.strokeWidth,
      size = _ref2.size,
      fontSize = _ref2.fontSize,
      theme = _ref2.theme,
      props = _objectWithoutProperties(_ref2, ["value", "max", "color", "strokeWidth", "size", "fontSize", "theme"]);

  var percentage = value / max * 100;
  var style = {
    root: {},
    path: {
      // Tweak path color:
      stroke: theme.palette[color].main,
      // Tweak path to use flat or rounded ends:
      strokeLinecap: 'butt'
    },
    // Customize the circle behind the path
    trail: {
      // Tweak the trail color:
      stroke: theme.palette.common.white
    },
    // Customize the text
    text: {
      // Tweak text color:
      stroke: '#f00',
      // Tweak text size:
      dominantBaseline: 'middle',
      textAnchor: 'middle'
    }
  };
  return _react.default.createElement(CustomTextProgressbar, Object.assign({
    counterClockwise: true,
    percentage: percentage,
    styles: style,
    strokeWidth: strokeWidth,
    size: size,
    color: color,
    fontSize: fontSize
  }, props), _react.default.createElement("div", null, _react.default.createElement("strong", null, value)));
};

Donut.defaultProps = {
  max: 100,
  color: 'primary',
  strokeWidth: 10,
  size: 'xs',
  fontSize: '16px'
};

var _default = (0, _styledComponents.withTheme)(Donut);

exports.default = _default;